import { Reducer } from 'redux';
import { Action, ActionType } from '../../actions';
import { EditorData } from '../../state/ProviderCredentialsV2/EditorData';

const updateProviderCredentialsV2EditorData: Reducer<EditorData> = (
  state: EditorData = new EditorData(),
  action: Action<ActionType, EditorData>
) => {
  switch (action.type) {
    case ActionType.PROVIDER_CREDENTIALS_V2_EDITOR_DATA_RESET:
      return new EditorData();
    case ActionType.PROVIDER_CREDENTIALS_V2_EDITOR_DATA_FETCHED:
      return { ...state, providerCredentialsV2EditorData: action.data as any };
    case ActionType.PROVIDER_CREDENTIALS_V2_EDITOR_DATA_COPIED:
      return { ...state, providerCredentialsV2EditorData: { ...(action.data as any) } };
    case ActionType.PROVIDER_CREDENTIALS_V2_EDITOR_DATA_UPDATED:
      return { ...state, providerCredentialsV2EditorData: { ...state.providerCredentialsV2EditorData, ...(action.data as any) } };
    case ActionType.PROVIDER_CREDENTIALS_V2_EDITOR_DATA_SAVED:
      return { ...state };
    case ActionType.PROVIDER_CREDENTIALS_V2_EDITOR_DATA_VALIDATED:
      return { ...state, validation: { ...(action.data as any) } };
    case ActionType.PROVIDER_CREDENTIALS_V2_EDITOR_SET_BOUND_ITEM:
      return { ...state, providerCredentialsV2EditorData: { ...state.providerCredentialsV2EditorData, ...(action.data as any) } };
    default:
      return state;
  }
};

export default updateProviderCredentialsV2EditorData;
